import { configureStore } from '@reduxjs/toolkit';
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import { AnswersState } from 'schemas/answerStateSchema';
import AnswersReducer from 'store/answers/answersSlice';

export type RootState = {
  answers: AnswersState;
};

export const store: ToolkitStore<RootState> = configureStore({
  reducer: {
    answers: AnswersReducer,
  },
});

export const clearLocalStorage = () => {
  localStorage?.removeItem('reduxState');
};

// write store to local storage on store change
const writeStoreStateToLocalStorage = () => {
  localStorage?.setItem('reduxState', JSON.stringify(store.getState()));
};
export const unsubscribeLocalStorage = store.subscribe(
  writeStoreStateToLocalStorage
);

// Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
